import React from 'react';

const About = () => ((
    <div>
        <h1>About us</h1>
        <p>
            BaconIpsum interface was built with React, React Router and Redux.
        </p>
    </div>
));

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js